import React from 'react';
import AuthenticatedAssetImage from '../AuthenticatedAssetImage';

const PreviewImageModal = ({ 
  isOpen, 
  onClose, 
  imageUrl, 
  imageAlt 
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: 'relative',
          maxWidth: '600px',
          maxHeight: '500px',
          width: '90%',
          height: 'auto',
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <AuthenticatedAssetImage
          src={imageUrl} 
          assetSize="preview"
          alt={imageAlt}
          style={{ 
            maxWidth: '100%', 
            maxHeight: 'inherit', 
            objectFit: 'contain',
            borderRadius: '4px'
          }} 
        />
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: 1000,
            fontSize: '18px',
            fontWeight: 'bold'
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default PreviewImageModal; 